var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27468 13.765C4.63963 14.0783 5.22801 14.0783 5.59296 13.765L11.7822 8.45084C12.0726 8.20144 12.0726 7.79856 11.7822 7.54916L5.59296 2.23501C5.22801 1.92166 4.63963 1.92166 4.27468 2.23501C3.90973 2.54836 3.90973 3.05356 4.27468 3.36691L9.66697 8.0032L4.26723 12.6395C3.90973 12.9464 3.90973 13.458 4.27468 13.765Z",
    fill: "#E1417F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.dd57d3f5.svg";
export { ForwardRef as ReactComponent };